import {action, makeObservable, observable} from 'mobx'

interface ErrorI {
  name: string
  status: number
  statusText: string
  message?: string
  url: string
  stack?: string
  body?: any
  createdAt: Date
  timeless: boolean
  isDisplayed: boolean
  timeOut: NodeJS.Timeout
  hideNow: any
  hideTimeout: any
}

export class Error implements ErrorI {
  status: number
  statusText: string
  message: string
  url: string
  stack: string
  body: any
  isDisplayed: boolean
  createdAt: Date
  timeless: boolean

  constructor(data: ErrorI) {
    this.status = data.status
    this.statusText = data.statusText
    this.message = data?.body?.message || data.message
    this.url = data.url
    this.stack = data.stack
    this.body = data.body
    this.isDisplayed = false
    this.createdAt = new Date()
    this.timeless = data.timeless || false

    makeObservable(this, {
      isDisplayed: observable,
      hide: action,
      hideTimeout: action,
    })
  }

  hide = () => (this.isDisplayed = true)

  hideNow = () => this.hide()

  hideTimeout = (timeout = 10000) => {
    if (!this.timeless && !this.timeOut)
      this.timeOut = setTimeout(() => this.hide(), timeout)
  }
  name: string
  timeOut: NodeJS.Timeout
}
